import 'react-toastify/dist/ReactToastify.css';

import GothamBlack from 'assets/fonts/GothamBlack.otf';
import GothamBold from 'assets/fonts/GothamBold.otf';
import GothamBook from 'assets/fonts/GothamBook.otf';
import GothamLight from 'assets/fonts/GothamLight.otf';
import ProximaNova from 'assets/fonts/ProximaNovaReg.otf';
import SFProBold from 'assets/fonts/SFPRODISPLAYBOLD.OTF';
import SFProMedium from 'assets/fonts/SFPRODISPLAYMEDIUM.OTF';
import SFProRegular from 'assets/fonts/SFPRODISPLAYREGULAR.OTF';

import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  @font-face {
    font-family: 'Proxima Nova';
    font-weight: normal;
    src: url(${ProximaNova}) format('opentype');
    font-display: swap;
  }

  @font-face {
    font-family: 'SFPro';
    font-weight: normal;
    src: url(${SFProRegular}) format('opentype');
    font-display: swap;
  }

  @font-face {
    font-family: 'SFPro';
    font-weight: bold;
    src: url(${SFProBold}) format('opentype');
    font-display: swap;
  }

  @font-face {
    font-family: 'SFPro';
    font-weight: medium;
    src: url(${SFProMedium}) format('opentype');
    font-display: swap;
  }

  @font-face {
    font-family: Gotham;
    font-weight: 300;
    src: url(${GothamLight}) format('opentype');
    font-display: swap;
  }

  @font-face {
    font-family: Gotham;
    font-weight: 900;
    src: url(${GothamBlack}) format('opentype');
    font-display: swap;
  }

  @font-face {
    font-family: Gotham;
    font-weight: bold;
    src: url(${GothamBold}) format('opentype');
    font-display: swap;
  }

  @font-face {
    font-family: Gotham;
    font-weight: normal;
    src: url(${GothamBook}) format('opentype');
    font-display: swap;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    /* transition: 1s; */
  }

  *:focus {
    outline: 0;
  }

  html {
    font-size: 62.5%;
  }

  @media (max-width: 1080px) {
    html {
      font-size: 58%;
    }
  }

  @media (max-width: 720px) {
    html {
      font-size: 54%;
    }
  }

  html, body, #root {
    height: 100%;
    scroll-behavior: smooth;
  }

  body {
    font-size: 1.6rem;
    font-family: SFPro, Arial, Helvetica, sans-serif;
    background-color: #ffffff;
    background-image: radial-gradient(circle at center, fff 0%, fff 100%);
    -webkit-font-smoothing: antialiased;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  button {
    font-family: SFPro, Arial, Helvetica, sans-serif;
    cursor: pointer;
  }

  ul {
    list-style: none;
  }

  .center {
    width: 100%;
    max-width: 1220px;
    margin: 0 auto;
    padding: 0 3rem;
  }

  strong {
    font-weight: 900;
  }

  h1 {
    font-weight: 900;
  }

  h2 {
    font-weight: 900;
  }

  h3 {
    font-weight: 900;
  }

  h4 {
    font-weight: 900;
  }

`;
